"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const styles = (theme) => (0, core_1.createStyles)({
    content: {
        padding: theme.spacing(),
        height: '800px'
    },
    contentTitle: {
        marginBottom: theme.spacing(2)
    },
    paymentInfo: {
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            alignItems: 'flex-start'
        }
    },
    lockIcon: {
        marginRight: theme.spacing(0.5),
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(0.25)
        }
    },
    purchaseBox: {
        display: 'flex',
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: 'rgb(10,84,139, 0.1)',
        borderRadius: theme.shape.borderRadius * 2,
        padding: theme.spacing(2),
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(4),
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            height: 120
        }
    },
    total: {
        display: 'flex',
        flexDirection: 'row'
    },
    totalTitle: {
        fontWeight: 100,
        marginRight: theme.spacing(0.5)
    },
    changeBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    },
    backIcon: {
        color: theme.palette.text.secondary
    },
    link: {
        display: 'flex',
        alignItems: 'center'
    },
    btnContainer: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    btn: {
        padding: '16px 48px',
        marginRight: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            marginRight: 0,
            marginBottom: theme.spacing(3)
        }
    },
    field: {
        fontFamily: 'Arial,sans-serif',
        marginTop: theme.spacing(0.5)
    },
    inputField: {
        marginTop: theme.spacing(0.5),
        height: 59,
        borderRadius: theme.shape.borderRadius,
        borderColor: 'rgba(0, 0, 0, 0.23)',
        borderStyle: 'solid',
        borderWidth: 1,
        paddingLeft: theme.spacing(2)
    },
    inputFieldFocus: {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
    },
    inputFieldInvalid: {
        borderColor: theme.palette.error.main
    },
    cvvContainer: {
        position: 'relative'
    },
    infoIconContainer: {
        position: 'absolute',
        right: theme.spacing(2),
        top: '50%'
    },
    infoIcon: {
        color: theme.palette.text.secondary,
        fontSize: 23,
        cursor: 'pointer'
    },
    popover: {
        pointerEvents: 'none',
        zIndex: 9999,
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    paper: {
        backgroundColor: '#F7F9FA',
        padding: theme.spacing(1)
    },
    cvvHelperImage: {
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    iframe: {
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        border: 0
    }
});
exports.default = styles;
//# sourceMappingURL=CheckoutModalStyle.js.map